export default "__VITE_ASSET__11890136__"